import { assign, createMachine } from "xstate"

const initialContext = {
  alumnos: [],
  error: "",
  filtros: [],
  loading: false,
  loadingoPersona: false,
  loadingEmail: false,
  loadingCurp: false,
  pagina: 1,
  isFetching: false,
  oPersona: {},
  oAlumno: {},
  notificacion: "",
  oPhotoCredencial: {},
  sListaIdStatus: "1,4",
  oDireccion: {},
  email: "",
  curp: "",
  descuentosInscripcion: [],
  mensajeExito: "",
}

const getParameterValue = (nombre, parameters) => {
  // Verificamos que exista 'Parametros' y que sea un array.
  if (parameters && Array.isArray(parameters)) {
    // Buscamos el parámetro que tenga el nombre nombre.
    const mensajeParam = parameters.find(param => param.Nombre === nombre)
    // Si lo encontramos, retornamos su Valor; de lo contrario, una cadena vacía.
    return mensajeParam ? mensajeParam.Valor : ""
  }

  // Si no hay 'Parametros', devolvemos cadena vacía.
  return ""
}

const controlEscolarMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "controlEscolar",
    initial: "idle",
    states: {
      idle: {
        on: {
          "controlescolar/PARAMETERS": {
            actions: ["setResponseParameters"],
          },
          "controlescolar/GET_DESCUENTOS_INSCRIPCION": {
            actions: ["setLoading", "unsetDescuentosInscripcion"],
            target: "idle",
          },
          "controlescolar/GET_DESCUENTOS_INSCRIPCION_SUCCESS": {
            actions: ["setDescuentosInscripcion", "unsetLoading", "unsetError"],
            target: "idle",
          },
          "controlescolar/GET_DESCUENTOS_INSCRIPCION_FAIL": {
            actions: ["setError", "unsetLoading", "unsetDescuentosInscripcion"],
            target: "idle",
          },
          "controlescolar/UNSET_DESCUENTOS_INSCRIPCION": {
            actions: ["unsetDescuentosInscripcion"],
            target: "idle",
          },
          "controlescolar/GET_CURP": {
            actions: ["setLoadingCurp"],
            target: "idle",
          },
          "controlescolar/GET_CURP_SUCCESS": {
            actions: ["setCurp", "unsetLoadingCurp", "unsetError"],
            target: "idle",
          },
          "controlescolar/GET_CURP_FAIL": {
            actions: ["setError", "unsetLoadingCurp"],
            target: "idle",
          },
          "controlescolar/GET_EMAIL": {
            actions: ["setLoadingEmail"],
            target: "idle",
          },
          "controlescolar/GET_EMAIL_SUCCESS": {
            actions: ["setEmail", "unsetLoadingEmail", "unsetError"],
            target: "idle",
          },
          "controlescolar/GET_EMAIL_FAIL": {
            actions: ["setError", "unsetLoadingEmail"],
            target: "idle",
          },
          "controlescolar/PUT_ALUMNO": {
            actions: ["setLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/PUT_ALUMNO_SUCCESS": {
            actions: [
              "setoAlumno",
              "setNotificacionOk",
              "unsetLoadingoPersona",
              "unsetError",
            ],
            target: "idle",
          },
          "controlescolar/PUT_ALUMNO_FAIL": {
            actions: ["setError", "unsetLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/GET_ALUMNO": {
            actions: ["setLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/GET_ALUMNO_SUCCESS": {
            actions: ["setoAlumno", "unsetLoadingoPersona", "unsetError"],
            target: "idle",
          },
          "controlescolar/GET_ALUMNO_FAIL": {
            actions: ["setError", "unsetLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/LISTAESTADOS": {
            actions: ["setListaEstados"],
            target: "idle",
          },
          "controlescolar/POST_PHOTO": {
            actions: ["setLoading"],
            target: "idle",
          },
          "controlescolar/POST_PHOTO_SUCCESS": {
            actions: ["setoPhotoCredencial", "unsetLoading", "unsetError"],
            target: "idle",
          },
          "controlescolar/POST_PHOTO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "controlescolar/UNSET_NOTIFICACION": {
            actions: ["unsetNotificacion"],
            target: "idle",
          },
          "controlescolar/UNSET_MENSAJE_EXITO": {
            actions: ["unsetMensajeExito"],
          },
          "controlescolar/SEND_PASSWORD": {
            actions: ["setLoading"],
            target: "idle",
          },
          "controlescolar/SEND_PASSWORD_SUCCESS": {
            actions: ["setNotificacion", "unsetLoading", "unsetError"],
            target: "idle",
          },
          "controlescolar/SEND_PASSWORD_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "controlescolar/PUT_ODIRECCION": {
            actions: ["setLoading", "setLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/PUT_ODIRECCION_SUCCESS": {
            actions: [
              "setoDireccion",
              "unsetLoading",
              "unsetError",
              "setNotificacionOk",
              "unsetLoadingoPersona",
            ],
            target: "idle",
          },
          "controlescolar/PUT_ODIRECCION_FAIL": {
            actions: ["setError", "unsetLoading", "unsetLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/PUT_PERSONA": {
            actions: ["setLoading"],
            target: "idle",
          },
          "controlescolar/PUT_PERSONA_SUCCESS": {
            actions: [
              "setoPersona",
              "unsetLoading",
              "unsetError",
              "setNotificacionOk",
            ],
            target: "idle",
          },
          "controlescolar/PUT_PERSONA_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "controlescolar/GET_PERSONA": {
            actions: ["setLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/GET_PERSONA_SUCCESS": {
            actions: ["setoPersona", "unsetLoadingoPersona", "unsetError"],
            target: "idle",
          },
          "controlescolar/GET_PERSONA_FAIL": {
            actions: ["setError", "unsetLoadingoPersona"],
            target: "idle",
          },
          "controlescolar/LISTA_ALUMNOS": {
            actions: ["setLoading"],
            target: "idle",
          },
          "controlescolar/LISTA_ALUMNOS_SUCCESS": {
            actions: ["setAlumnos", "unsetLoading", "unsetError"],
            target: "idle",
          },
          "controlescolar/LISTA_ALUMNOS_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "controlescolar/UNSET_LISTA_ALUMNOS": {
            actions: ["unsetAlumnos"],
            target: "idle",
          },
          CONTROLESCOLAR_SETFILTRO: {
            actions: ["setFiltros"],
            target: "filtrado",
          },
          "controlescolar/LOGOUT": {
            actions: ["resetMachine"],
            target: "idle",
          },
          "controlescolar/UNSET_ERROR": {
            actions: ["unsetError"],
            target: "idle",
          },
          "controlescolar/CREATE_ALUMNO": {
            actions: ["setLoading"],
            target: "idle",
          },
          "controlescolar/CREATE_ALUMNO_SUCCESS": {
            actions: ["setoAlumno", "unsetLoading", "unsetError"],
            target: "idle",
          },
          "controlescolar/CREATE_ALUMNO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
        },
      },
      filtrado: {
        on: {
          CONTROLESCOLAR_UNSETFILTRO: {
            actions: ["unsetFiltros"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setResponseParameters: assign({
        mensajeExito: (_, event) => {
          if (event.payload && event.payload.parameters) {
            return getParameterValue(
              "Mensaje_Exito",
              event.payload.parameters || []
            )
          }
        },
      }),
      unsetMensajeExito: assign({
        mensajeExito: "",
      }),
      setListaEstados: assign({
        sListaIdStatus: (_, event) => event.payload.data,
      }),
      setMensajeEnvioPassword: assign({
        error: (_, event) => event.payload.data,
      }),
      setoPhotoCredencial: assign({
        oPhotoCredencial: (_, event) => event.payload.data,
      }),
      setNotificacion: assign({
        notificacion: (_, event) => event.payload.data,
      }),
      setNotificacionOk: assign({
        notificacion: "Todo Ok",
      }),
      unsetNotificacion: assign({
        notificacion: "",
      }),
      setoDireccion: assign({
        oDireccion: (_, event) => event.payload.data,
      }),
      setoPersona: assign({
        oPersona: (_, event) => event.payload.data,
      }),
      setoAlumno: assign({
        oAlumno: (_, event) => event.payload.data,
      }),
      setEmail: assign({
        email: (_, event) => event.payload.data,
      }),
      setCurp: assign({
        curp: (_, event) => event.payload.data,
      }),
      setDescuentosInscripcion: assign({
        descuentosInscripcion: (_, event) => event.payload.data,
      }),
      unsetDescuentosInscripcion: assign({
        descuentosInscripcion: (_, event) => [],
      }),
      setAlumnos: assign({
        alumnos: (_, event) => event.payload.alumnos,
      }),
      unsetAlumnos: assign({
        alumnos: (_, event) => [],
      }),
      setFiltros: assign({
        filtros: (_, event) => event.payload,
      }),
      unsetFiltros: assign({
        filtros: [],
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : event.payload
            ? event.payload
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
      setLoadingoPersona: assign({
        loadingoPersona: true,
      }),
      unsetLoadingoPersona: assign({
        loadingoPersona: false,
      }),
      setLoadingEmail: assign({
        loadingEmail: true,
      }),
      unsetLoadingEmail: assign({
        loadingEmail: false,
      }),
      setLoadingCurp: assign({
        loadingCurp: true,
      }),
      unsetLoadingCurp: assign({
        loadingCurp: false,
      }),
    },
  }
)

export default controlEscolarMachine
